import { render, staticRenderFns } from "./editCustomer.vue?vue&type=template&id=079f4761"
import script from "./editCustomer.vue?vue&type=script&lang=js"
export * from "./editCustomer.vue?vue&type=script&lang=js"
import style0 from "./editCustomer.vue?vue&type=style&index=0&id=079f4761&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports